import React from 'react';

interface OnClickProps {
  label: string;
  value: string;
  disabled?: boolean;
  disableMark?: string;
}

interface Props {
  label: string;
  value: string;
  disabled?: boolean;
  disableMark?: string;
  onClick: (props: OnClickProps) => void;
}

const DropDownOption = ({label, value, disabled, disableMark, onClick}: Props) => {
  const onClickOption = React.useCallback(
    () => onClick({label, value, disabled}),
    [label, value, disabled]
  );
  return (
    <div
      className={`ecr-dropdown-row ${disabled ? 'disabled' : ''}`}
      onClick={onClickOption}
      role="presentation">
      {label}
      {disabled ? ` ${disableMark || '*'}` : ''}
    </div>
  );
};

export default DropDownOption;
